<template>
  <div v-if="activeLoading.regraterId">
    <h1>Lieferung <span class="key heavy">L{{ activeLoading.loadingId }}</span></h1>
    <ul class="output col-8 mb-0">
      <li v-if="isGrain"><label class="col-3">Produkt</label> {{ getProduct(activeLoading.productId) }}</li>
      <li><label class="col-3">Aufkäufer</label> {{ getRegrater(activeLoading.regraterId) }}</li>
      <li v-if="activeLoading.deliverySlipNumber"><label class="col-3">{{ isGrain ? 'Auslagerung' : 'Lieferschein' }}</label> {{ activeLoading.deliverySlipNumber }}</li>
      <li v-if="activeLoading.licensePlateNumber"><label class="col-3">Kennzeichen</label> {{ activeLoading.licensePlateNumber }}</li>
      <li v-if="activeLoading.licensePlateTrailer"><label class="col-3">Anhänger</label> {{ activeLoading.licensePlateTrailer }}</li>
    </ul>
    <div v-if="!finishedLoading()" class="w-100 mb-3">
      <button @click="editLoading()" class="edit">~</button>
    </div>

    <div v-if="!isGrain && activeLoading.vessel.length">
      <h2>Ladeliste</h2>
      <ul class="list w-100">
        <li v-for="(vessel, idx) in getLoadedVessels()"
            :key="vessel.vesselId" class="row">
          <div v-if="!finishedLoading()" class="col-1 pl-0">
          <button @click="openDialog(
              { element: 'der Big Bag',nbr: vessel.uniqueNumber, weight: vessel.weight, uid: vessel.uniqueId})" class="del">-</button>
          </div>
          <div class="col-1">{{ idx+1 }}</div>
          <div :class="'col-'+(finishedLoading() ? '4 pl-0' : 3)"><label>{{ (vessel.number ? (vessel.isBigBag ? 'BB ' : 'C ')+vessel.number : vessel.uniqueNumber) }}<br/>{{ vessel.supplier }}</label></div>
          <div class="col-3 pr-0 text-right">{{ getVesselWeight(vessel) }}</div>
<!--          <span v-if="getVesselChilds(vessel.vesselId)"><br/>{{ getVesselChildsText(vessel) }}</span>-->
<!--          <div v-if="finishedLoading()" class="col-3 text-right">-->
<!--            <api-pdf-link method="bigbagslip" :elementId="vessel.uniqueId" class="float-right"/>-->
<!--          </div>-->
        </li>
      </ul>
      <div class="row mb-3">
        <div class="col-5 bold">Summe</div>
        <div class="col-3 bold text-right" :class="!finishedLoading() && 'pr-0'">{{ totalWeight() }} kg</div>
      </div>
      <div v-if="activeLoading.vessel.length || finishedLoading()" class="row mb-3">
        <div class="col-8">
          <api-pdf-link method="loadingslip" label="Lieferschein PDF" :elementId="activeLoading.uniqueId" class="float-right"/>
        </div>
      </div>
      <!-- todo: if alwera -->
      <div v-if="finishedLoading() && loadingBatches.length">
        <div v-for="(batch, idx) in loadingBatches" :key="idx" class="row mb-3">
        <div v-if="loadingForRegrater(3, batch.batchId)" class="col-8">
          <api-pdf-link
              method="batchstockslip"
              :label="'Partieblatt: '+ batch.uniqueNumber +'/'+ batch.number"
              :elementId="batch.uniqueId"
              class="float-right"
          />
        </div>
      </div>
      </div>
    </div>
    <div v-if="!isGrain && !finishedLoading()">
      <h2>Big Bags<!-- / Container--></h2>
      <ul class="nav" style="margin:0 0 0.5rem 0">
        <li @click="showQrReader" class="qr">
          QR-Code
          <img src="@/assets/images/icon-qr-code.svg"/>
        </li>
      </ul>
      <form @submit.prevent="saveBagLoading" class="col-8">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="bag">BB</label>
          </div>
          <select
              v-model="bag"
              class="custom-select custom-select-lg" id="bag">
            <option value="0">oder BigBag Auswählen...</option>
            <option
                v-for="bag in this.loadableVessels"
                :key="bag.vesselId"
                :value="bag.vesselId">
              {{ getBigBagLabel(bag) }}
            </option>
          </select>
        </div>
        <button type="submit" class="mt-1">Geladen</button>

        <details
            v-if="this.loadableVessels.length > 0 && !finishedLoading()"
            class="col-8">
          <summary><h2>Lagerliste</h2></summary>
          <ul class="list mb-0">
            <li v-for="vessel in this.loadableVessels"
                :key="vessel.vesselId"
                class="row">
              <div class="col-7">
                <span v-if="vesselStockLocation">{{ vessel.stockLocation }}&nbsp;</span>
                <b>{{ vessel.uniqueNumber }}</b>{{ getBigBagLabel(vessel, true, true, false) }}
              </div>
              <div class="col-1"><button class="add" @click="addVessel(vessel.vesselId)">+</button></div>
            </li>
          </ul>
        </details>

        <div class="input-group form-check mt-4 mb-2">
          <input v-model="notifyRegrater" type="checkbox" class="form-check" id="notifyRegrater">
          <label v-if="regraterType === 3" class="form-check-label ml-2" for="notifyRegrater">
            Lieferschein und Partieblatt/-blätter<br> an den Aufkäufer senden.</label>
          <label v-else class="form-check-label ml-2" for="notifyRegrater">Lieferschein an den Aufkäufer senden.</label>
        </div>
      </form>

      <div v-if="storing" class="col-8 mt-3 text-center">
        Die Daten werden gespeichert...
      </div>
      <button @click="finishLoading" class="mt-3" :disabled="storing">Abschluss</button>
    </div>
  </div>
  <div v-else-if="!finishedLoading()" class="row">
    <h1>Verladen</h1>
    <form @submit.prevent="save" class="col-8">
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <label class="input-group-text" for="regraterId">Aufkäufer</label>
        </div>
        <select
            v-model="regraterId"
            class="custom-select custom-select-lg" id="regraterId" required>
          <option>Auswählen..</option>
          <option
              v-for="regrater in regraters"
              :key="regrater.contactId"
              :value="regrater.contactId"
          >{{ regrater.name }}</option>
        </select>
      </div>

      <div
          v-if="products.length > 1"
          class="input-group mb-3">
        <div class="input-group-prepend">
          <label class="input-group-text" for="supplierId">Produkt</label>
        </div>
        <select
            v-model="productId"
            @change="productChanged"
            class="custom-select custom-select-lg" id="supplierId"
            required>
          <option>Auswählen..</option>
          <option
              v-for="product in products"
              :key="product.productId"
              :value="product.productId">{{ product.name }}</option>
        </select>
      </div>

      <div
          v-if="!products.length || productId === 1"
          class="input-group mb-3">
        <div class="input-group-prepend">
          <label class="input-group-text" for="deliverySlipNumber">Lieferschein</label>
        </div>
        <input v-model="deliverySlipNumber" type="text" class="form-control form-control-lg" id="deliverySlipNumber"
               placeholder="">
      </div>

      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <label class="input-group-text" for="truck">Kennzeichen</label>
        </div>
        <input v-model="truck" type="text" class="form-control form-control-lg" id="truck" placeholder="">
      </div>

      <div
          v-if="!products.length || productId === 1"
          class="input-group mb-3">
        <div class="input-group-prepend">
          <label class="input-group-text" for="trailer">Kennzeichen Anhänger</label>
        </div>
        <input v-model="trailer" type="text" class="form-control form-control-lg" id="trailer" placeholder="">
      </div>

      <button type="submit">Starten</button>
    </form>
  </div>

  <div
    v-if="isGrain && loadedBatches.length > 0"
    class="row">
    <h2>Geladen</h2>
    <div class="w-100">
      <batch-list
          :batches="loadedBatches" :add-batch-enabled="false" :show-regraters="false"/>
    </div>
    <ul class="output col-8 mb-0">
      <li class="bold"><label class="col-3 bold">Menge</label> {{ globalFunctions.parseNumber(activeLoading.loadingWeight) }} kg</li>
    </ul>
  </div>
  <div
      v-if="isGrain && loadedBatches.length > 0 && !finishedLoading()"
      class="row">
    <div v-if="canWrite" class="col-8 mb-3">
      <button @click="resetBatchLoading" class="del">-</button>
    </div>
    <form class="row">
      <div class="input-group form-check mt-3">
        <input v-model="finishBatch" type="checkbox" class="form-check" id="dryerCleaned">
        <label class="form-check-label ml-2" for="dryerCleaned">Charge abschließen</label>
      </div>
    </form>
    <div v-if="storing" class="col-8 mt-3 text-center">
      Die Daten werden gespeichert...
    </div>
    <button @click="finishLoading" class="done" :disabled="storing">Abschluss</button>
  </div>
  <div
    v-else-if="isGrain && finishedLoading()"
    class="row">

    <h2>Auslagerungsschein</h2>
    <div class="col-2">{{ activeLoading.deliverySlipNumber }}</div>
    <div class="col-6 text-right">
      <api-pdf-link method="storeoutslip" :elementId="loadingId" label="PDF" class="float-right"/>
    </div>

  </div>
  <div
    v-if="isGrain && !loadedBatches.length && !finishedLoading()"
    class="row">
    <h2>Chargen</h2>
    <div
      v-if="batches.length"
      class="w-100">
      <form @submit.prevent="saveBatchLoading" class="row">
        <div class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="bag">Charge</label>
          </div>
          <select
              v-model="batchId"
              class="custom-select custom-select-lg" id="bag">
            <option>Auswählen..</option>
            <option
                v-for="batch in batches"
                :key="batch.batchId"
                :value="batch.batchId">
              {{ getBatchLabel(batch) }}
            </option>
          </select>
        </div>
        <div class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="loadingWeight">Menge</label>
          </div>
          <input v-model="loadingWeight" type="number" step=".1" class="form-control form-control-lg"
                 id="loadingWeight" placeholder="">
          <div class="input-group-append">
            <span class="input-group-text">kg</span>
          </div>
        </div>

        <div v-if="loadingStored" class="col-8 mt-3 text-right">
          <img class="opened" src="@/assets/images/icon-done.svg"/>
          gespeichert
        </div>
        <button type="submit" class="mt-1">Speichern</button>
      </form>
    </div>
    <div v-else
      class="col-8">
      Kein Getreide im Lager.
    </div>
  </div>

  <div v-if="finishedLoading()"
       class="row mt-5 mb-4">
    <div class="col-7 offset-1">
      <button
          @click="resetConfirmation"
          class="optional mt-2">Abschluss zurücksetzen</button>
    </div>
  </div>
  <div v-else-if="!finishedLoading() && loadingId > 0 && activeLoading.vessel.length === 0"
       class="row mt-5 mb-4">
    <div class="col-7 offset-1">
      <button
          @click="modalDeleteLoading = true"
          class="optional mt-2">Lieferung löschen</button>
    </div>
  </div>

  <app-btn-back class="pt-2" routerLink="LoadingPage"/>
  <app-qr-reader v-if="qr" :doEmit="true" @qrRead="qrRead"/>
  <app-modal-dialog v-if="modalOpened" @abortDialog="abortDialog" @confirmDialog="confirmDialog">
    <h1>Entfernen bestätigen</h1>
    <div class="w-100">{{ modalText }}</div>
    <div class="w-100"><strong>{{ modalElement }}</strong></div>
  </app-modal-dialog>
  <app-modal-dialog v-if="modalDeleteLoading" @abortDialog="abortDialogDelete" @confirmDialog="confirmDialogDelete">
    <h1>Löschen der Lieferung bestätigen</h1>
    <div class="w-100 alert-error">{{ modalError }}</div>
  </app-modal-dialog>
  <popup-loading-editor v-if="loadingEditorOpened" :element="activeLoading" :regraters="regraters"
                        @abortDialog="abortLoadingEdit" @confirmDialog="saveLoadingEdit"></popup-loading-editor>
</template>

<script>
import { inject } from 'vue'
import ApiPdfLink from "@/components/ApiPdfLink";
import AppModalDialog from "@/components/AppModalDialog";
import PopupLoadingEditor from "@/components/PopupLoadingEditor";
import BatchList from "@/components/BatchList.vue";

export default {
  name: "LoadingShow",
  components: {BatchList, AppModalDialog,ApiPdfLink,PopupLoadingEditor},
  data() {
    return {
      loadingId: null,
      regraterId: null,
      regraterType: 0,
      productId: 1,
      loadableVessels: null,
      activeLoading: {
        vessel: [],
      },
      loadingBatches: [],
      deliverySlipNumber: '',
      truck: '',
      trailer: '',
      bag: 0,
      loadingDone: false,
      storedBags: [],
      batchId: null,
      loadingWeight: null,
      loadingStored: false,
      finishBatch: false,
      qr: false,
      modalOpened: false,
      modalText: '',
      modalError: '',
      modalElement: '',
      modalUid: '',
      modalDeleteLoading: false,
      loadingEditorOpened: false,
      globalFunctions: inject('globalFunctions'),
      notifyRegrater: true,
      storing: false,
    }
  },
  props: {
    id: {
      required: false,
      type: String
    }
  },
  async created() {
    await this.$store.dispatch('getItemList', {entityName: 'supplier'})
    await this.$store.dispatch('getItemList', {entityName: 'regrater'})
    await this.$store.dispatch('getItemList', {entityName:'product'})

    if (!this.isGrain) {
      // this.$store.state.vessel = []
      await this.$store.dispatch('getItemList', {entityName: 'batch', method: 'dried'}) // performance: not loaded or loadingBatchIds, fields: key, uniqueNumber, uid
    } else {
      await this.$store.dispatch('getItemList', {entityName: 'batch', method: 'stored'})
    }
    // console.log('---- batches store', this.$store.state.batch)

    if (this.id) {
      this.loadingId = this.id
      await this.getActiveLoading()
      await this.getLoadableVessels()

      this.setRegraterType()
    }
    // console.log('---- activeLoading', this.activeLoading)

  },
  computed: {
    regraters() {
      return this.$store.state.regrater
    },
    products() {
      return this.$store.state.product
    },
    isGrain() {
      return this.activeLoading.productId > 1
    },
    batches() {
      return this.$store.state.batch
    },
    loadedBatches() {
      return this.activeLoading.batchId ? this.$store.state.batch.filter(batch => batch.batchId === this.activeLoading.batchId) : []
    },
    canWrite() {
      return this.$store.getters.canWrite
    },
    vesselStockLocation() {
      return this.$store.getters.vesselStockLocation
    },
  },
  methods: {
    // vessels() {
    //   return this.$store.state.vessel
    // },
    parseNumber(number) {
      if (parseInt(number) != number)
        return number
      else
        return parseInt(number)
    },
    editLoading() {
      this.loadingEditorOpened = true
    },
    abortLoadingEdit() {
      this.loadingEditorOpened = false
    },
    totalWeight() {
      const vessels = this.activeLoading.vessel
      let total = 0

      for (let idx in vessels) {
        total += parseFloat(vessels[idx]['weight'])
      }
      return this.globalFunctions.parseNumber(total)
    },
    setRegraterType() {
      this.regraterType = this.$store.state.regrater.find(
          regrater => regrater.contactId === this.activeLoading.regraterId).regraterType
    },
    async save() {
      const data = {
        regraterId: this.regraterId,
        productId: this.productId,
        deliverySlipNumber: this.deliverySlipNumber,
        licensePlateNumber: this.truck,
        licensePlateTrailer: this.trailer,
      }
      const response = await this.$store.dispatch('cruItem', {name: 'loading', data})
      // console.log('saved',response.id)
      this.loadingId = response.id
      this.activeLoading = {
        ...this.activeLoading,
        loadingId: response.id,
        regraterId: this.regraterId,
        productId: this.productId,
        deliverySlipNumber: this.deliverySlipNumber,
        licensePlateNumber: this.truck,
        licensePlateTrailer: this.trailer,
        label: this.deliverySlipNumber || this.truck
      }
      this.setRegraterType()
      this.getLoadableVessels()
    },
    async saveLoadingEdit({regraterId, productId, deliverySlipNumber,licensePlateNumber,licensePlateTrailer}) {
      const data = {
        regraterId,deliverySlipNumber,licensePlateNumber,licensePlateTrailer
      }
      const response = await this.$store.dispatch('cruItem',
          {name: 'loading', id: this.loadingId, data: data})
      const changedRegrater = regraterId != this.activeLoading.regraterId

      this.activeLoading = {
        ...this.activeLoading,
        regraterId,
        productId,
        deliverySlipNumber,
        licensePlateNumber,
        licensePlateTrailer,
        label: deliverySlipNumber || licensePlateNumber
      }

      if (response && response.success === true) {
        this.abortLoadingEdit()
        if (changedRegrater) await this.getLoadableVessels()
      }
    },
    async saveBagLoading(vesselId) {
      const data = {
        loadingId: this.loadingId
      }

      await this.$store.dispatch('cruItem', {name: 'vessel', id: vesselId > 0 ? vesselId : this.bag, data})
      await this.getActiveLoading()

      // const bagIndex = this.storedBags.findIndex(bag => bag.id === this.bag)
      // this.storedBags.splice(bagIndex, 1)
      await this.getLoadableVessels()
    },
    async saveBatchLoading() {
      // console.log('saveBatchLoading',this.batchId,this.loadingWeight,this.finishBatch)
      this.loadingStored = false
      const data = {
        batchId: this.batchId,
        loadingWeight: this.loadingWeight,
      }

      const response = await this.$store.dispatch('cruItem', {name: 'loading', id: this.loadingId, data})
      if (response && response.success) {
        this.loadingStored = true
        this.activeLoading.batchId = this.batchId
        this.activeLoading.loadingWeight = this.loadingWeight
      }
      // await this.getActiveLoading()
    },
    async resetBatchLoading() {
      const data = {
        batchId: 0,
        loadingWeight: 0,
      }
      const response = await this.$store.dispatch('cruItem', {name: 'loading', id: this.loadingId, data})
      if (response && response.success) {
        this.activeLoading.batchId = null
        this.activeLoading.loadingWeight = null
      }
    },
    addVessel(vesselId) {
      this.saveBagLoading(vesselId)
    },
    async finishLoading() {
      this.storing = true
      const data = {
        finishedLoading: 1,
        finishBatch: this.finishBatch,
        batchId: this.activeLoading.batchId ?? this.batchId,
        notifyRegrater: this.notifyRegrater,
      }
      const response = await this.$store.dispatch('cruItem',
          {name: 'loading', id: this.loadingId, data})

      this.storing = false
      if (response && response.success) {
        this.activeLoading.finishedLoading = true
      }
      // this.$props.batch.bagged = true
    },
    finishedLoading() {
      // console.log('###',this.activeLoading.finishedLoading)
      if (this.activeLoading.finishedLoading == '0')
        return false

      return this.activeLoading.finishedLoading
    },
    async getActiveLoading() {
      this.activeLoading = await this.$store.dispatch('getItem', {name: 'loading', id: this.loadingId})
      this.activeLoading.label = this.activeLoading.deliverySlipNumber || this.activeLoading.truck
      // console.log('activeLoading',this.activeLoading)

      // get batch uids
      if (this.activeLoading && this.activeLoading.vessel) {
        this.loadingBatches = []

        /*this.activeLoading.vessel.forEach(
          vessel => this.loadingBatches.filter(
              batch => batch.batchId === vessel.batchId)[0] ??
              (this.loadingBatches.push(this.$store.state.batch.filter(batch => batch.batchId === vessel.batchId)[0]))
          )*/
        this.activeLoading.vessel.forEach(vessel => {
          if (vessel.batchId) {
            const existingBatch = this.loadingBatches.find(batch => batch.batchId === vessel.batchId);
            if (!existingBatch) {
              const matchedBatch = this.$store.state.batch.find(batch => batch.batchId === vessel.batchId);
              if (matchedBatch) {
                this.loadingBatches.push(matchedBatch);
              }
            }
          }
        });

        // console.log('loadingBatches', this.loadingBatches)
      }
    },
    async getLoadableVessels() {
      //this.loadableVessels = await this.$store.dispatch('getItemList', {entityName: 'vessel', method: 'loadable', returnData: true})
      this.loadableVessels = await this.$store.dispatch('getItemsByParent',
          {entityName: 'vessel', method: 'loadable', returnData: true, regraterId: this.activeLoading.regraterId})
    },
    async resetConfirmation() {
      const response = await this.$store.dispatch('cruItem', { name: 'loading', id: this.loadingId, data: { finishedLoading: 0 } })
      if (response && response.success) {
        this.activeLoading.finishedLoading = false
      }
    },
    showQrReader() {
      this.qr = true
      window.scroll(0, 0);
    },
    qrRead(params) {
      if (params.qrString) {
        this.setBagId(params.qrString)
        this.saveBagLoading()
      }
      this.qr = false
    },
    formattedInt(number) {
      return parseInt(number).toLocaleString('de-DE')
    },
    setBagId(id) {
      const vessel = this.loadableVessels.filter((vessel) => vessel.uniqueNumber === id)[0];

      /*const pos = id.indexOf('.')
      if (pos >= 0)
        id = id.substring(pos+1)
      if (id.indexOf('BB') === 0)
        id = id.substring(2)*/

      this.bag = vessel.vesselId
    },
    openDialog({element, nbr, weight, uid}) {
      this.modalText = 'Soll '+ element +' aus der Ladeliste entfernt werden?'
      this.modalElement = nbr + ' mit '+ this.parseNumber(weight) +' kg'
      this.modalOpened = true
      this.modalUid = uid
    },
    abortDialog() {
      this.modalOpened = false
    },
    async confirmDialog() {
      this.modalOpened = false
      this.bag = ''
      await this.$store.dispatch('delItem', {name:'loading', uid:this.modalUid})
      await this.getActiveLoading()
      await this.getLoadableVessels()
    },
    abortDialogDelete() {
      this.modalDeleteLoading = false
    },
    async confirmDialogDelete() {
      const response = await this.$store.dispatch('delItem', { name: 'loading', uid: this.activeLoading.uniqueId })
      if (response && response.success) {
        this.modalDeleteLoading = false
        this.$router.push({ path: '/loading', query: { delNbr: this.loadingId } }); // path, um neu zu laden
      } else if (response && response.err) {
        this.modalError = response.err
      }
    },
    getLoadedVessels() {
      return this.activeLoading.vessel.filter(vessel => parseInt(vessel.parent_vesselId) === 0 || vessel.parent_vesselId == null)
    },
    getVesselWeight(vessel) {
      let weight = parseFloat(vessel.weight)

      if (parseFloat(vessel.parent_vesselId) > 0)
        return ''

      const childs = this.getVesselChilds(vessel.vesselId)
      if (childs) {
        for (const child of childs) {
          weight += parseFloat(child.weight)
        }
      }

      return this.globalFunctions.parseNumber(weight) + ' kg'
    },
    getVesselChilds(vesselId) {
      const childs = this.activeLoading.vessel.filter(vessel => vessel.parent_vesselId == vesselId)

      if (childs.length > 0)
        return childs

      return null
    },
    getVesselChildsText(vessel) {
      let texts = [
        vessel.uniqueNumber + ' ' + parseInt(vessel.weight) + ' kg'
      ]
      const childs = this.getVesselChilds(vessel.vesselId)

      for (const child of childs) {
        texts.push(child['uniqueNumber'] + ' ' + this.parseNumber(child.weight) + ' kg')
      }

      return texts.join(', ')
    },
    getSupplier(id) {
      if (!id || !this.$store.state.supplier) return ''
      const item = this.$store.state.supplier.find(item => item.contactId === id)
      if (!item) return ''
      return item.name
    },
    getRegrater(id) {
      if (!id || !this.$store.state.regrater) return '–'
      const item = this.$store.state.regrater.find(item => item.contactId === id)
      if (!item) return '–'
      return item.name
    },
    getBigBagLabel(bag, addInfo = true, withoutNumber = false, addLocation = true) {
      let label = ''

      if (bag.number && !withoutNumber) {
        const batch = this.$store.state.batch.find(b => b.batchId === bag.batchId)
        if (batch && batch.uniqueNumber)
          label += batch.uniqueNumber +' '+ (bag.isBigBag ? 'BB ' : 'C ')+ bag.number
        else
          label += (bag.isBigBag ? 'BB ' : 'C ')+ bag.number
      } else if (!withoutNumber)
        label += bag.uniqueNumber

      if (addInfo) {
        label += ' | '+ this.parseNumber(bag.weight) +' kg | '
        if (addLocation && bag.stockLocation) label += bag.stockLocation +' | '
      }
      label += bag.supplier

      if (!this.activeLoading.regraterId) label += ' › '+ bag.regrater

      return label
    },
    getBatchLabel(batch) { // console.log(batch)
      return (batch.incomingStockLocation ? batch.incomingStockLocation +' ' : '')+ batch.uniqueNumber + ' ' + this.getSupplier(batch.supplierId)
    },
    getProduct(id) {
      if (!id || !this.$store.state.product) return '–'
      const item = this.$store.state.product.find(item => item.productId === id)
      if (!item) return '–'
      return item.name
    },
    loadingForRegrater(regraterType, batchId) {
      // validate if loaded vessels are for regrater type
      let regraterIds = []

      if (this.activeLoading.vessel) {
        for (const vessel of this.activeLoading.vessel) {
          if (vessel.batchId == batchId && vessel.regraterId)
            regraterIds.push(vessel.regraterId)
        }
      }

      if (!regraterIds.length) // for to early method calls on rendering
        return false

      for (const regraterId of regraterIds) {
        const regrater = this.$store.state.regrater.find(item => item.contactId === regraterId)

        if (!regrater)
          continue

        if (this.$store.state.regrater.find(item => item.contactId === regraterId).regraterType == regraterType)
          return true
      }

      return false
    },
  }
}
</script>

<style scoped>

</style>